/* EF Universal PDP — variant picker + qty + ATC + express checkout
   Phase 4.3 (2026-05-04). State management for cards/pills/swatches/dropdowns.
   Reads variants from <script id="efUniVariantsData"> embedded in template. */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('efUniForm');
    if (!form) return;

    var variantsData;
    try {
      variantsData = JSON.parse(document.getElementById('efUniVariantsData').textContent);
    } catch (e) {
      console.warn('[ef-uni-pdp] variants data parse failed', e);
      return;
    }

    var variantIdInput = document.getElementById('efUniVariantId');
    var atcBtn         = document.getElementById('efUniATC');
    var atcText        = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    var priceCurrent   = document.getElementById('efUniPriceCurrent');
    var priceCompare   = document.getElementById('efUniPriceCompare');
    var priceSave      = document.getElementById('efUniPriceSave');
    var priceFrom      = document.getElementById('efUniPriceFrom');
    var express        = document.getElementById('efUniExpressCheckout');

    /* Build state: {axisPosition: selectedValue} */
    var state = {};
    document.querySelectorAll('.ef-uni-variant-group').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-axis'), 10);
      var sel = group.querySelector('.is-active, [aria-checked="true"]')
             || group.querySelector('[data-variant-option]')
             || group.querySelector('.ef-uni-variant-select');
      if (!sel) return;
      state[pos] = sel.dataset.variantOption || sel.value;
    });

    /* If product has no option groups (single variant), state stays {} and
       we just track first variant. */
    if (!Object.keys(state).length && variantsData.length) {
      state[1] = variantsData[0].option1;
    }

/* Bromic-only native-variant purchasing refinement. No catalog prices changed. */
    var bromic = form.hasAttribute('data-ef-bromic-order');
    function bromicCandidates(pos, val) {
      return variantsData.filter(function(v){
        if(v['option'+pos]!==val)return false;
        for(var i=1;i<pos;i++)if(state[i]&&v['option'+i]!==state[i])return false;
        return true;
      });
    }
    function bromicResolve(pos) {
      if(!bromic)return;
      var candidates=bromicCandidates(pos,state[pos]);
      if(!candidates.length)return;
      candidates.sort(function(a,b){
        function score(v){var n=v.available?1:0;for(var i=pos+1;i<=3;i++)if(v['option'+i]===state[i])n+=4;return n;}
        return score(b)-score(a);
      });
      var chosen=candidates[0],changed=[];
      for(var i=pos+1;i<=3;i++){if(chosen['option'+i]&&state[i]!==chosen['option'+i]){changed.push(chosen['option'+i]);state[i]=chosen['option'+i];}}
      var note=form.querySelector('[data-bromic-adjustment]');
      if(note){note.textContent=changed.length?'Available configuration selected: '+changed.join(' · ')+'. Review your selection below.':'';note.hidden=!changed.length;}
    }
    function bromicRender(v) {
      if(!bromic)return;
      form.querySelectorAll('.ef-uni-variant-group').forEach(function(group){
        var pos=Number(group.dataset.axis);
        group.querySelectorAll('[data-variant-option]').forEach(function(button){
          var candidates=bromicCandidates(pos,button.dataset.variantOption);
          button.hidden=!candidates.length;
          button.disabled=!candidates.length;
          button.setAttribute('aria-disabled',String(!candidates.length));
          var parent=button.closest('li');if(parent)parent.hidden=!candidates.length;
          var delta=button.querySelector('[data-price-delta]');
          if(delta){
            var exact=candidates.find(function(x){return [1,2,3].every(function(i){return i===pos||!state[i]||x['option'+i]===state[i];});});
            var prices=candidates.map(function(x){return x.price;});
            delta.textContent=exact?fmtPrice(exact.price):(prices.length?'From '+fmtPrice(Math.min.apply(null,prices)):'');
            delta.classList.remove('is-included');
          }
        });
        var select=group.querySelector('select');if(select){Array.from(select.options).forEach(function(o){o.hidden=!bromicCandidates(pos,o.value).length;o.disabled=o.hidden;});select.value=state[pos]||'';}
        var label=group.querySelector('.ef-uni-dropdown__trigger-label');if(label)label.textContent=state[pos]||'';
      });
      var summary=form.querySelector('[data-bromic-summary]');
      if(summary)summary.textContent=v ? (v.title==='Default Title'?'Selected product':v.title.replace(/ \/ /g,' · '))+(v.sku?' · SKU '+v.sku:'') : 'Choose an available configuration';
      var amount=form.querySelector('[data-bromic-total]');if(amount)amount.textContent=v?fmtPrice(v.price):'—';
    }
    if(bromic){
      form.querySelectorAll('.ef-uni-variant-group').forEach(function(group){
        var controls=Array.from(group.querySelectorAll('[data-variant-option]'));
        if(/power|watt|voltage|length|size|channel/i.test(group.dataset.axisName||'')){
          controls.sort(function(a,b){return a.dataset.variantOption.localeCompare(b.dataset.variantOption,'en',{numeric:true});}).forEach(function(b){var li=b.closest('li');var node=li||b;node.parentElement.appendChild(node);});
        }
        controls.forEach(function(b){var chip=b.querySelector('.ef-uni-variant-swatch__chip');if(chip){var color=b.dataset.variantOption;var colors={'black':'#171717','matte black':'#171717','white':'#ffffff','stainless steel':'linear-gradient(120deg,#b7bbbd,#f2f3f3,#969d9f)'};var value=colors[color.toLowerCase()];if(value)chip.style.background=value;var label=document.createElement('span');label.className='ef-bromic-color-label';label.textContent=color;b.appendChild(label);}});
      });
      var notice=document.createElement('p');notice.className='ef-bromic-adjustment';notice.dataset.bromicAdjustment='';notice.setAttribute('role','status');notice.hidden=true;
      var receipt=document.createElement('div');receipt.className='ef-bromic-receipt';receipt.innerHTML='<span class="ef-bromic-receipt__label">Your selection</span><p data-bromic-summary></p><div><span>Unit price</span><strong data-bromic-total></strong></div>';
      var buy=form.querySelector('.ef-uni-buy-row');if(buy){buy.before(notice);buy.before(receipt);}
      var intro=document.createElement('p');intro.className='ef-bromic-intro';intro.textContent='Choose your specifications. Prices shown are per item; your exact selection appears below.';form.prepend(intro);
    }

    function findMatchingVariant() {
      return variantsData.find(function (v) {
        return (!state[1] || v.option1 === state[1])
            && (!state[2] || v.option2 === state[2])
            && (!state[3] || v.option3 === state[3]);
      });
    }

    function fmtPrice(cents) {
      var amount = (cents / 100);
      var hasFrac = amount % 1 !== 0;
      var formatted = amount.toLocaleString('en-US', hasFrac ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {});
      return '$' + formatted;
    }

    /* Every native variant uses its exact assigned media, including URL entry. */
    var galleryVariantId = null;
    var gallerySyncToken = 0;
    function syncGrillMedia(v) {
      if (galleryVariantId === v.id) return;
      galleryVariantId = v.id;
      var token = ++gallerySyncToken;
      var media = v.featured_media || v.featured_image;
      var position = media && Number(media.position);
      if (!position || position < 1) return;
      var attempts = 0;
      function apply() {
        if (token !== gallerySyncToken) return;
        var gallery = window.EFGallery && window.EFGallery.main;
        if (gallery && !gallery.destroyed && gallery.slides && gallery.slides.length >= position) {
          gallery.slideTo(position - 1, 0);
        } else if (++attempts < 60) {
          window.setTimeout(apply, 100);
        }
      }
      apply();
    }

    function updateUI() {
      var v = findMatchingVariant();

      /* Update group label "selected" display */
      document.querySelectorAll('.ef-uni-variant-group').forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-axis'), 10);
        var disp = group.querySelector('[data-selected-display]');
        if (disp && state[pos]) disp.textContent = state[pos];
      });

      /* Active state on cards/pills/swatches + per-axis info box */
      var axisActiveDesc = {}, axisActiveSample = {};
      document.querySelectorAll('[data-variant-option]').forEach(function (el) {
        var pos = parseInt(el.dataset.axisPosition, 10);
        var match = state[pos] === el.dataset.variantOption;
        el.classList.toggle('is-active', match);
        el.setAttribute('aria-checked', match ? 'true' : 'false');
        if (match && el.dataset.infoDesc) axisActiveDesc[pos] = el.dataset.infoDesc;
        if (match && el.dataset.infoSample) axisActiveSample[pos] = el.dataset.infoSample;
      });
      /* Show description for currently active option (per axis) */
      document.querySelectorAll('[data-axis-info-for]').forEach(function (info) {
        var pos = parseInt(info.dataset.axisInfoFor, 10);
        var desc = axisActiveDesc[pos];
        if (desc) {
          info.textContent = desc; info.hidden = false;
          if (axisActiveSample[pos]) {
            try {
              var sample = new URL(axisActiveSample[pos], location.href);
              if (sample.protocol === 'https:') {
                var sampleLink = document.createElement('a');
                sampleLink.href = sample.href; sampleLink.target = '_blank'; sampleLink.rel = 'noopener noreferrer';
                sampleLink.textContent = 'View manufacturer color sample'; sampleLink.style.textDecoration = 'underline'; sampleLink.style.textUnderlineOffset = '2px';
                info.appendChild(document.createTextNode(' ')); info.appendChild(sampleLink);
              }
            } catch (_) {}
          }
        }
        else { info.textContent = ''; info.hidden = true; }
      });

      /* Pill price labels — "Included" for cheapest in this option (with current other selections),
         "+$X" for upcharge over cheapest. Matches Woodland Direct UX. */
      // Build per-axis: { pos → { val → price assuming other axes match state } }
      var probePrices = {};
      document.querySelectorAll('.ef-uni-variant-pill, .ef-uni-variant-card').forEach(function (pill) {
        var pos = parseInt(pill.dataset.axisPosition, 10);
        var val = pill.dataset.variantOption;
        if (!probePrices[pos]) probePrices[pos] = {};
        var probeState = Object.assign({}, state);
        probeState[pos] = val;
        var probeVar = variantsData.find(function (vv) {
          return (!probeState[1] || vv.option1 === probeState[1])
              && (!probeState[2] || vv.option2 === probeState[2])
              && (!probeState[3] || vv.option3 === probeState[3]);
        });
        probePrices[pos][val] = probeVar ? probeVar.price : null;
      });
      // For each axis, find min price (= base for that axis)
      var axisMin = {};
      Object.keys(probePrices).forEach(function (pos) {
        var prices = Object.values(probePrices[pos]).filter(function (p) { return p != null; });
        axisMin[pos] = prices.length ? Math.min.apply(null, prices) : null;
      });
      // Render delta per pill
      document.querySelectorAll('.ef-uni-variant-pill, .ef-uni-variant-card').forEach(function (pill) {
        var deltaEl = pill.querySelector('[data-price-delta]');
        if (!deltaEl) return;
        var pos = parseInt(pill.dataset.axisPosition, 10);
        var val = pill.dataset.variantOption;
        var price = probePrices[pos][val];
        var min = axisMin[pos];
        if (price == null || min == null) { deltaEl.textContent = ''; return; }
        if (price === min) {
          deltaEl.textContent = 'Included';
          deltaEl.classList.add('is-included');
        } else {
          deltaEl.textContent = '+' + fmtPrice(price - min);
          deltaEl.classList.remove('is-included');
        }
      });

      bromicRender(v);
      if (!v) {
        if (atcText) atcText.textContent = 'Unavailable';
        if (atcBtn) atcBtn.disabled = true;
        if (express) express.disabled = true;
        return;
      }

      syncGrillMedia(v);

      /* Update form variant id */
      if (variantIdInput) variantIdInput.value = v.id;

      /* Update price + compare + save (dynamic per variant) */
      if (priceCurrent) priceCurrent.textContent = fmtPrice(v.price);
      if (priceCompare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceCompare.textContent = fmtPrice(v.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (priceSave) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceSave.textContent = 'Save ' + fmtPrice(v.compare_at_price - v.price);
          priceSave.hidden = false;
        } else {
          priceSave.hidden = true;
        }
      }
      /* Gallery "Save $X" badge — keep in sync with the selected size (was static,
         showing the largest size's MSRP minus the cheapest price). */
      var saveBadgeWrap = document.getElementById('efUniSaveBadgeWrap');
      var saveBadgeAmt  = document.getElementById('efUniSaveBadgeAmt');
      if (saveBadgeWrap) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (saveBadgeAmt) saveBadgeAmt.textContent = fmtPrice(v.compare_at_price - v.price);
          saveBadgeWrap.style.display = 'flex';
        } else {
          saveBadgeWrap.style.display = 'none';
        }
      }
      if (priceFrom) {
        /* Hide "From" once a specific variant is selected and no other axis varies */
        priceFrom.hidden = true;
      }

      /* Update ATC text */
      if (atcText) {
        atcText.textContent = v.available
          ? 'Add to Cart — ' + fmtPrice(v.price * (bromic ? Math.max(1, Math.min(99, parseInt(form.querySelector('.ef-uni-qty__input').value, 10) || 1)) : 1))
          : 'Sold Out';
      }
      var cartPending = form.dataset.efUniCartPending === 'true' || form.dataset.efUniSwitchPending === 'true';
      if (atcBtn) atcBtn.disabled = !v.available || cartPending;
      if (express) express.disabled = !v.available || cartPending;

      /* Update URL with ?variant=<id> */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Click handler — cards / pills / swatches / custom dropdown options */
    form.addEventListener('click', function (e) {
      /* Custom dropdown trigger toggle */
      var trigger = e.target.closest('.ef-uni-dropdown__trigger');
      if (trigger) {
        e.preventDefault();
        var dd = trigger.closest('.ef-uni-dropdown');
        var open = dd.getAttribute('data-open') === 'true';
        /* Close all other dropdowns */
        form.querySelectorAll('.ef-uni-dropdown[data-open="true"]').forEach(function (other) {
          other.setAttribute('data-open', 'false');
          other.querySelector('.ef-uni-dropdown__trigger').setAttribute('aria-expanded', 'false');
        });
        dd.setAttribute('data-open', open ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        return;
      }
      var target = e.target.closest('[data-variant-option]');
      if (!target) return;
      e.preventDefault();
      var pos = parseInt(target.dataset.axisPosition, 10);
      if(bromic && (target.hidden || target.disabled))return;
      state[pos] = target.dataset.variantOption;
      bromicResolve(pos);

      /* If the click came from a custom dropdown option, sync trigger + close menu */
      var ddOption = target.closest('.ef-uni-dropdown__option');
      if (ddOption) {
        var dd = target.closest('.ef-uni-dropdown');
        if (dd) {
          var trig = dd.querySelector('.ef-uni-dropdown__trigger');
          var trigLabel = trig.querySelector('.ef-uni-dropdown__trigger-label');
          if (trigLabel) trigLabel.textContent = target.dataset.variantOption;
          dd.setAttribute('data-open', 'false');
          trig.setAttribute('aria-expanded', 'false');
          /* Sync hidden select for form submit */
          var sel = dd.querySelector('.ef-uni-variant-select');
          if (sel) sel.value = target.dataset.variantOption;
          /* Update aria-selected on options */
          dd.querySelectorAll('.ef-uni-dropdown__option').forEach(function (o) {
            var on = o.dataset.variantOption === target.dataset.variantOption;
            o.classList.toggle('is-active', on);
            if (o.parentElement) o.parentElement.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }
      }

      updateUI();

      /* After updateUI, refresh the dropdown trigger price for axis that own a dropdown */
      var v = findMatchingVariant();
      if (v && ddOption) {
        var ddTriggerPrice = target.closest('.ef-uni-dropdown')?.querySelector('.ef-uni-dropdown__trigger-price');
        if (ddTriggerPrice) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            ddTriggerPrice.innerHTML = '<s style="color:#8A8579;font-weight:400;margin-right:5px">' + fmtPrice(v.compare_at_price) + '</s>' + fmtPrice(v.price);
          } else {
            ddTriggerPrice.textContent = fmtPrice(v.price);
          }
        }
      }

      /* Sync gallery to variant media when available (color swatches mainly) */
      if (!(v && (v.featured_media || v.featured_image)) && target.dataset.mediaIndex !== undefined && window.EFGallery && window.EFGallery.main) {
        var idx = parseInt(target.dataset.mediaIndex, 10);
        if (!isNaN(idx) && idx >= 0) {
          try { window.EFGallery.main.slideTo(idx); } catch (err) {}
        }
      }
    });

    /* Close custom dropdowns on outside click */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.ef-uni-dropdown')) return;
      form.querySelectorAll('.ef-uni-dropdown[data-open="true"]').forEach(function (dd) {
        dd.setAttribute('data-open', 'false');
        dd.querySelector('.ef-uni-dropdown__trigger').setAttribute('aria-expanded', 'false');
      });
    });

    /* Change handler — dropdowns */
    form.addEventListener('change', function (e) {
      var sel = e.target.closest('.ef-uni-variant-select');
      if (!sel) return;
      var pos = parseInt(sel.dataset.axisPosition, 10);
      state[pos] = sel.value;
      bromicResolve(pos);
      updateUI();
    });

    /* Quantity stepper */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      var input = form.querySelector('.ef-uni-qty__input');
      if (!input) return;
      var delta = parseInt(btn.dataset.qty, 10);
      var current = parseInt(input.value, 10) || 1;
      var next = Math.max(1, Math.min(99, current + delta));
      input.value = next;
      if (bromic) updateUI();
    });

    /* Keep Bromic purchase totals synchronized for typing, paste and steppers. */
    ['input', 'change'].forEach(function (eventName) {
      form.addEventListener(eventName, function (e) {
        if (!bromic || !e.target.matches('.ef-uni-qty__input')) return;
        if (eventName === 'change') e.target.value = Math.max(1, Math.min(99, parseInt(e.target.value, 10) || 1));
        updateUI();
      });
    });

    form.addEventListener('ef:uni-cart-state', updateUI);

    /* Express Checkout — silent ATC + redirect to /checkout */
    if (express) {
      express.addEventListener('click', function (e) {
        e.preventDefault();
        if (express.disabled || form.dataset.efUniCartPending === 'true' || form.dataset.efUniSwitchPending === 'true') return;
        if (form.hasAttribute('data-ef-tool-set-form') && !form.reportValidity()) return;
        var v = findMatchingVariant();
        if (!v || !v.available) return;
        form.dataset.efUniCartPending = 'true';
        form.setAttribute('aria-busy', 'true');
        var oldError = document.getElementById('efUniCartError');
        if (oldError) oldError.hidden = true;
        updateUI();
        express.style.opacity = '0.6';
        var qtyInput = form.querySelector('.ef-uni-qty__input');
        var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [Object.assign({ id: v.id, quantity: qty }, form.hasAttribute('data-ef-tool-set-form') ? { properties: { Finish: form.querySelector('[data-tool-finish]:checked').value } } : {})] })
        })
        .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
        .then(function (data) {
          if (!data || Number(data.status) >= 400 || data.errors || data.error ||
              !(data.id || (Array.isArray(data.items) && data.items.length))) {
            throw new Error('cart-add-invalid-response');
          }
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('[ef-uni-pdp] express checkout failed', err);
          form.dataset.efUniCartPending = 'false';
          form.setAttribute('aria-busy', 'false');
          updateUI();
          express.style.opacity = '';
          var message = "We couldn't confirm whether this item was added. Check your cart before trying again.";
          if (form._efUniShowCartError) form._efUniShowCartError(message);
          else alert(message);
        });
      });
    }

    /* Same-size fire pit siblings share this live form. Keep all native price,
       stock and checkout paths on the server-rendered destination variants. */
    if (document.querySelector('[data-ef-fp-family]')) {
      function validateFirepitProduct(next, target) {
        if (!Array.isArray(next) || !next.length || !target || !target.handle || !target.productId) return false;
        var selected = next.find(function (item) { return String(item.id) === String(target.id); });
        if (!selected || next.some(function (item) { return !Number.isSafeInteger(Number(item.id)) || !Number.isSafeInteger(item.price) || item.price < 0 || typeof item.available !== 'boolean'; })) return false;
        return Array.from(form.querySelectorAll('[data-variant-option]')).every(function (option) {
          return next.some(function (item) { return item['option' + option.dataset.axisPosition] === option.dataset.variantOption; });
        });
      }
      form._efFirepitNative = {
        validate: validateFirepitProduct,
        setPending: function (pending) {
          form.dataset.efUniSwitchPending = String(pending);
          form.setAttribute('aria-busy', String(pending || form.dataset.efUniCartPending === 'true'));
          updateUI();
        },
        apply: function (next, target) {
          if (!validateFirepitProduct(next, target)) return false;
          variantsData = next;
          var chosen = next.find(function (item) { return String(item.id) === String(target.id); });
          state = {};
          [1, 2, 3].forEach(function (pos) { if (chosen['option' + pos]) state[pos] = chosen['option' + pos]; });
          form.dataset.productId = String(target.productId);
          document.getElementById('efUniVariantsData').textContent = JSON.stringify(next);
          form.querySelectorAll('.ef-uni-variant-select').forEach(function (select) { select.value = state[select.dataset.axisPosition] || select.value; });
          updateUI();
          return true;
        }
      };
      form.addEventListener('submit', function (event) {
        if (form.dataset.efUniSwitchPending === 'true') { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
    }

    /* Restore state from URL ?variant=ID on load */
    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlVariant) {
      var v = variantsData.find(function (vv) { return String(vv.id) === urlVariant; });
      if (v) {
        if (v.option1) state[1] = v.option1;
        if (v.option2) state[2] = v.option2;
        if (v.option3) state[3] = v.option3;
      }
    }

    /* Alturi 30: a paid cover needs an explicit choice. A saved/shared
       ?variant= link is restored above and remains authoritative. Only this
       product's first visit defaults to its existing no-cover variant. */
    if (form.getAttribute('data-product-id') === '7229899145298' &&
        /\/products\/summerset-alturi-built-in-gas-grill-30\/?$/.test(window.location.pathname)) {
      var explicitAlturiVariant = urlVariant && variantsData.some(function (item) {
        return String(item.id) === urlVariant;
      });
      if (!explicitAlturiVariant) {
        var alturiWithoutCover = variantsData.find(function (item) {
          return item.option1 === state[1] && item.option2 === 'No Thank You' &&
                 (!state[3] || item.option3 === state[3]);
        });
        if (alturiWithoutCover) state[2] = alturiWithoutCover.option2;
      }
    }

    updateUI();
  }

  /* Accordion uses native <details>/<summary> — no JS needed. */

  /* ════ Finish-image fallback for swatches without variant image ════
     Liquid renders swatch chip with hex bg when variant lacks featured_media.
     This pass replaces those with finish images from window.EF_FINISH_IMAGES
     (extracted from the customizer's ef-cfg-images.js). 11/12 mantel finishes,
     plus 100+ door/screen finishes — applies to any product on universal PDP. */
  function applyFinishImages() {
    var map = window.EF_FINISH_IMAGES;
    if (!map) return;
    var swatches = document.querySelectorAll('.ef-uni-variant-swatch:not(.ef-uni-variant-swatch--img)');
    swatches.forEach(function (sw) {
      var name = (sw.getAttribute('aria-label') || '').trim().toLowerCase();
      if (!name) return;
      var url = map[name];
      if (!url) return;
      var chip = sw.querySelector('.ef-uni-variant-swatch__chip');
      if (!chip) return;
      chip.style.background = '';
      chip.style.backgroundImage = 'url(' + url + ')';
      chip.style.backgroundSize = 'cover';
      chip.style.backgroundPosition = 'center';
      sw.classList.add('ef-uni-variant-swatch--img');
    });
  }

  /* ════ Phase 5.1 — Mobile FAB auto-hide when expert card in viewport ════ */
  function initFab() {
    var fab = document.getElementById('efUniFab');
    var expert = document.querySelector('.ef-uni-expert');
    if (!fab || !expert) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        fab.classList.toggle('is-hidden', e.isIntersecting);
      });
    }, { threshold: 0.4 });
    io.observe(expert);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initFab(); applyFinishImages(); });
  } else {
    init();
    initFab();
    applyFinishImages();
  }
})();
